// Utilidades de tela herdadas do protótipo (esc, toast, LOGO, localStorage de preferências) e
// conversões de competência "AAAA-MM" ↔ rótulo. Nada de regra de negócio aqui.

import { MESES as MESES_MOTOR, rotuloCompetencia, type Competencia } from '../motor/index.js';

declare const __LOGO__: string;
declare const __FUNDO_HOME__: string;

/** Imagens embutidas do protótipo (extraídas de prototipo/original.html pelo build). */
export const LOGO: string = __LOGO__;
export const FUNDO_HOME: string = __FUNDO_HOME__;

export const MESES: string[] = MESES_MOTOR.slice();

export const esc = (s: any): string =>
  String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

// ── Toast ─────────────────────────────────────────────────────
let _toastTimer: any = null;
export function toast(msg: string, type?: string, duration?: number) {
  let t = document.getElementById('lbx-toast');
  if (!t) { t = document.createElement('div'); t.id = 'lbx-toast'; t.className = 'toast'; document.body.appendChild(t); }
  t.textContent = msg;
  t.className = 'toast ' + (type || '');
  if (_toastTimer) clearTimeout(_toastTimer);
  const el = t;
  setTimeout(function () { el.classList.add('show'); }, 10);
  _toastTimer = setTimeout(function () { el.classList.remove('show'); }, duration || 2500);
}

// ── Preferências no aparelho (só interface/rascunho; regra 5 do port) ──
export function lsGet(k: string): any { try { const v = localStorage.getItem('lbx_' + k); return v ? JSON.parse(v) : null; } catch { return null; } }
export function lsSet(k: string, v: any) { try { localStorage.setItem('lbx_' + k, JSON.stringify(v)); } catch (e) { console.warn('lsSet failed:', e); } }
export function lsDel(k: string) { try { localStorage.removeItem('lbx_' + k); } catch { /* sem storage */ } }

// ── Competência ──────────────────────────────────────────────
export function compTxt(c: Competencia): string { return c.ano + '-' + String(c.mes).padStart(2, '0'); }
export function compDeTxt(t: string): Competencia { const p = String(t || '').split('-'); return { ano: parseInt(p[0] || '0', 10), mes: parseInt(p[1] || '0', 10) }; }
export function rotuloTxt(t: string): string { return t ? rotuloCompetencia(compDeTxt(t)) : ''; }
export function pad2(n: number) { return (n < 10 ? '0' : '') + n; }

export function fmtBRL(n: number) { return (n || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
export function fmtNumBR(n: number) { return (n || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
export function fmtDateBR(iso: string | null) { if (!iso) return '—'; const p = String(iso).split('-'); return p.length === 3 ? (p[2] + '/' + p[1] + '/' + p[0]) : iso; }

/** Baixa um arquivo servido pela API (CSV, anexo): o cookie de sessão vai junto. */
export function baixarUrl(url: string, nome?: string) {
  const a = document.createElement('a'); a.href = url; if (nome) a.download = nome; a.rel = 'noopener';
  document.body.appendChild(a); a.click(); a.remove();
}

/** Cores por faixa de nota (régua única, decisão 7.3), em cada paleta que o protótipo usava. */
export const COR_FORM: Record<string, string> = { muito_bom: '#16a34a', bom: '#2E5C8A', regular: '#d97706', insuficiente: '#dc2626', anexada: '#4f46e5' };
export const COR_REL: Record<string, string> = { muito_bom: '#16a34a', bom: '#2563eb', regular: '#d97706', insuficiente: '#dc2626', anexada: '#94a3b8' };
export const FUNDO_REL: Record<string, string> = { muito_bom: '#f0fdf4', bom: '#eff6ff', regular: '#fffbeb', insuficiente: '#fef2f2', anexada: '#f8fafc' };
export const BORDA_REL: Record<string, string> = { muito_bom: '#86efac', bom: '#93c5fd', regular: '#fde68a', insuficiente: '#fca5a5', anexada: '#e2e8f0' };
